import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Input } from 'antd';
import { editGroupMetaDataRequest } from '../redux/actions/edit_group_meta_data.actions';

export default connect()(class GroupForm extends Component {
  groupDataChange = (event) => {
      this.props.dispatch(editGroupMetaDataRequest(this.props.groupsList._id, { [event.target.name]: event.target.value }));
  };

  render() {
      const { groupsList } = this.props;
      return (
          groupsList ? (
              <Fragment>
                  <Fragment>
                      <h3 style={{ margin: '0' }}>
                          {groupsList.name}
                          {' '}
                          {<small>{` (${groupsList.abbr})`}</small>}
                      </h3>
                      <h3 className="page-subhead subhead">{groupsList.description}</h3>
                  </Fragment>
                  <Row style={{ paddingBottom: '2%' }}>
                      <Col span={6}>
                          <div className="group_list_data_label">Abbreviation: </div>
                          <Input
                              type="text"
                              name="abbr"
                              placeholder="Example group abbreviation"
                              onBlur={this.groupDataChange}
                              maxLength={5}
                              defaultValue={groupsList.abbr}
                          />
                      </Col>
                      <Col span={6} offset={1}>
                          <div className="group_list_data_label">Description: </div>
                          <Input
                              type="text"
                              name="description"
                              maxLength={200}
                              placeholder="Group name description"
                              onBlur={this.groupDataChange}
                              defaultValue={groupsList.description}
                          />
                      </Col>
                  </Row>
              </Fragment>
          ) : null
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/components/GroupForm.js